module.exports = __webpack_public_path__ + "img/deletevector.ffecf626.png";